import React from "react";
import PropTypes from "prop-types";
import "react-colorful/dist/index.css";

import ColorPicker from "icons/ColorPicker";
import Popover from "core/Popover";
import Tooltip from "core/Tooltip";
import ShapeStatus from "./ShapeStatus";
import ShapeList from "./ShapeList";
import Close from "core/ReusableIcons/Close";

import { EditingControlContent, RemoveShapeButton } from "./styles";
import colors from "core/colors";

import { useIconEditorDispatch } from "js/contexts/IconEditorContext";
import { SHAPES } from "./constants";

const ShapeControls = ({
    activeColor,
    recent,
    palette,
    colorTextInputValue,
    shape
}) => {
    const dispatch = useIconEditorDispatch();

    const handleShapeSelect = e =>
        dispatch({
            type: "SET_SHAPE",
            payload: e.target.value
        });

    const showRemoveShapeButton = shape !== SHAPES.SQUARE;

    const removeShape = () => {
        dispatch({
            type: "SET_SHAPE",
            payload: SHAPES.SQUARE
        });
    };

    return (
        <>
            <EditingControlContent>
                <ColorPicker
                    title="Background Color"
                    background
                    activeColor={activeColor}
                    recent={recent}
                    palette={palette}
                    colorTextInputValue={colorTextInputValue}
                    shape={shape}
                />
            </EditingControlContent>
            <EditingControlContent shapes>
                <Popover
                    triggerTextOrElement={<ShapeStatus currentShape={shape} />}
                    popoverPlacement="top"
                    buttonStyleType="none"
                    darkMode
                    isFluidWidth
                    ariaLabel="choose icon shape"
                >
                    <ShapeList
                        handleShapeSelect={handleShapeSelect}
                        currentShape={shape}
                    />
                </Popover>

                {showRemoveShapeButton && (
                    <RemoveShapeButton
                        onClick={removeShape}
                        aria-label="reset icon shape"
                    >
                        <Close
                            size={{ width: 8, height: 8 }}
                            fillColor={colors.secondary.manatee}
                        />
                    </RemoveShapeButton>
                )}
            </EditingControlContent>
        </>
    );
};

ShapeControls.propTypes = {
    activeColor: PropTypes.string,
    recent: PropTypes.array,
    palette: PropTypes.array,
    colorTextInputValue: PropTypes.string,
    shape: PropTypes.string
};

export default React.memo(ShapeControls);
